<div class="img">
  <img src="../../../assets/img/whyhuiospay.png" alt="map svg">
</div>

<!-- map section-->
<div class="overlay" data-aos="fade-up"
data-aos-anchor-placement="bottom-bottom"
data-aos-duration="2000">
  <div class="overlay-left">
    <div class="bold-text">
      <h2>
        We make an impact
        in ways that improve life
        far beyond everyone else
      </h2>
    </div>
    <!-- <div class="btn-holder">
      <div class="btn">
        <button class="btn-agent">
          <a href="/become-agent" style="color: inherit; text-decoration: none;">
          Become POS agent
        </a>
      </button>
      </div>
      <div class="btn">
        <button class="btn-agent-setup">
          <a href="/become-merchant" style="color: inherit; text-decoration: none;">
            Become POS merchant
          </a></button>
      </div>
    </div> -->

  </div>
  <!-- <div class="overlay-right">
    <img src="../../../assets/img/user3.png" alt="user-smilling">
  </div> -->
</div>
<!--End  map section-->